import React from 'react'

function Header() {
  return (
    <div>
        <h1>Hangman</h1>
        <p>Find the hidden letter - Enter a letter</p>
    </div>
  )
}

export default Header;